import $ from 'jquery';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Popper from '@material-ui/core/Popper';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import InputLabel from '@material-ui/core/InputLabel';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Divider from '@material-ui/core/Divider';
import ENGINES, { ENGINES_NAMES, getEngineIndex, coreToKNode, uniqueServers, getEnginesListFromAvailableServers, showEngineInfo, showAnalizeButton, PRODUCT_IDS } from '../../../utils';
import { getUserInfo } from '../../../api';
import Badge from '@material-ui/core/Badge';
import Tooltip from '@material-ui/core/Tooltip';
import { isMobile } from 'react-device-detect';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import LinearProgress from '@material-ui/core/LinearProgress';
import MuiButton from "@material-ui/core/Button";
import OptionDialog from './OptionsDialog';

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: 20
  },
  card: {
    width: 'max-content',
    margin: 10,
    textAlign: 'center'
  },
  selServerInfoContainer: {
    width: "100%",
    textAlign: 'center',
    marginTop: 30
  },
  formControlLabel: {
    fontSize: '0.8rem',
    '& label': { fontSize: '0.8rem' }
  },
  formControl: {
    minWidth: '100%',
  },
  popover: {
    pointerEvents: 'none',
    width: "30vw"
  },
  paper: {
    padding: theme.spacing(1),
    backgroundColor: "#FAEFB5"
  },
  paper2: {
    width: "max-content",
  },
  // New added styel
  formControlWeb: {
    backgroundColor: "#ffffff",
    minWidth: '100%',
    "&&&:before": {
      borderBottom: "none"
    },
    "&&:after": {
      borderBottom: "none"
    }
  },
  cardContent: {
    padding: theme.spacing(1)
  },
  menuItem: {
    color: "#3f9673",
    fontWeight: "bold"
  },
  menuItemSecond: {
    color: "red",
  },
  webView: {
    width: 'max-content',
    textAlign: 'center',
    backgroundColor: "#ffffff",
    boxShadow: 'rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  formControlLabelWeb: {
    margin: theme.spacing(0),
    padding: theme.spacing(0, 1, 0, 0),
    color: "#000000",
    fontWeight: 'bold'
  },
  priceForWeb: {
    color: "#000000"
  },
  webEngineTitle: {
    fontWeight: "bold",
    color: "#009673",
    fontSize: "22px",
  },
  scrollIcon: {
    width: "18px",
    height: "18px",
    minWidth: "18px",
    minHeight: "18px",
    backgroundColor: "#3f9673",
    color: "#ffffff",
    borderRadius: "50%"
  },
  linerLoading: {
    width: "80%",
    textAlign: "center",
    marginTop: 30,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
    stopAnalizeButton: {
      width: "90%",
      margin: "0px auto",
      backgroundColor: "#f44336",
      color: "#ffffff"
    },
    scrollServersContainer: {
      boxShadow: "rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px",
      textAlign: "center",
      width: "15vw",
      marginRight: 2
    }
  },
});

const WhiteTextField = withStyles({
  root: {
    '& .MuiInputBase-input': {
      color: '#00000',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
      boxShadow: 'none'
    },
    '& .MuiInput-underline:hover:before': {
      borderBottom: 'none',
      boxShadow: 'none'
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
      boxShadow: 'none'
    },
  },
})(TextField);

const DisabledButton = withStyles({
  root: {
    "&.Mui-disabled": {
      pointerEvents: "auto"
    }
  }
})(MuiButton);

const SelectField = withStyles({
  root: {
    "&.MuiInputBase-input": {
      paddingBottom: '0px',
      fontWeight: "bold",
      color: "#009673",
      fontSize: "22px",
    }
  }
})(Select);

const ButtonWithTooltip = ({ tooltipText, disabled, onClick, ...other }) => {
  const adjustedButtonProps = {
    disabled,
    component: disabled ? "div" : undefined,
    onClick: disabled ? undefined : onClick
  };
  return (
    <Tooltip title={tooltipText} placement="top" arrow>
      <DisabledButton {...other} {...adjustedButtonProps} />
    </Tooltip>
  );
};

function getEngine(cores, qtEngine) {
  if (qtEngine) return ENGINES.indexOf(qtEngine)
  if (cores) return getEngineIndex(cores)
  return 0
}

class SplitButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      anchorRef: React.createRef(),
      selectedEngine: null,
      enginesList: [],
      availableServers: [],
      enginesOptionsList: {},
      counter: 0,
      isOrdering: {},
      availableServersIntervalId: null,
      pingAliveIntervalId: null,
      orderedCores: {},
      // New added state
      coreNumberWeb: {},
      isOpenOptionDialog: false,
      optionText: null
    }
  }

  componentDidMount() {
    this.getAvailableServers();

    $.ajax({
      url: '/billing/get_engines_options_list',
      success: enginesOptionsList => { this.setState({ enginesOptionsList }) }
    });

    this.pingAlive();
    window.stopOrderedServer = this.stopServer;
  }

  updateEnginesList = (availableServersList) => {
    const { orderedEnginesInfo } = this.props;
    this.setState({
      availableServers: getEnginesListFromAvailableServers(availableServersList, orderedEnginesInfo),
      coreNumberWeb: this._getAvailableServerName(getEnginesListFromAvailableServers(availableServersList, orderedEnginesInfo))
    });
  }

  _getAvailableServerName = (object) => {
    const { coreNumberWeb } = this.state;
    const { user } = this.props;
    const { subscription } = user;

    const title = Object.keys(object);
    const obj = {};

    for (let index = 0; index < title.length; index++) {
      if (coreNumberWeb[title[index]] > 0) {
        obj[title[index]] = coreNumberWeb[title[index]];

      } else {
        if (!subscription) {
          obj[title[index]] = 0;
        }

        if (subscription) {
          if (parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-month'] || parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-year']) {
            obj[title[index]] = object[title[index]].length > 1 ? 1 : 0;
          }
          else {
            obj[title[index]] = object[title[index]].length > 2 ? 2 : 0;
          }
        }

      }
    }
    return obj
  }

  getAvailableServers = () => {
    const interval = setInterval(() => {
      $.ajax({
        url: '/api/available_servers',
        method: 'GET',
        success: response => { this.updateEnginesList(response) }
      });
    }, 3000);

    this.setState({ availableServersIntervalId: interval });
  };

  handleMenuItemClick = (event, engine) => {
    this.setState((state) => (
      { selectedEngine: state.selectedEngine != engine ? engine : null, counter: 0 }
    ))
  };

  componentWillUnmount() {
    const { availableServersIntervalId, pingAliveIntervalId } = this.state;

    clearInterval(availableServersIntervalId);
    clearInterval(pingAliveIntervalId);
    this.setState({
      availableServersIntervalId: null,
      pingAliveIntervalId: null
    });
  }

  pingAlive = () => {
    const interval = setInterval(() => {
      const { orderedEnginesInfo } = this.props;
      const engines = Object.keys(orderedEnginesInfo);

      for (let i = 0; i < engines.length; i++) {
        $.ajax({
          url: `/api/ping_alive?engine=${engines[i]}`,
          method: 'GET',
          success() {
            console.log('Pinged');
          }
        });
      }
    }, 5000);

    this.setState({ pingAliveIntervalId: interval });
  };

  showEngines = () => {
    this.setState((state) => ({
      open: !state.open
    }));
  };

  orderIsDisabled = pricePerMinute => {
    var currentBallance = this.state.balance;
    //    const currentBallance = 10000;
    return currentBallance <= pricePerMinute;
  };

  handleClose = (event) => {
    if ((this.state.anchorRef.current && this.state.anchorRef.current.contains(event.target)) || event.target.id === 'page-top') {
      return;
    }
    this.setState({ open: false, selectedEngine: null });
  };

  handleChangeOptions = (event, option, engine, type) => {
    const { value, checked } = event.target;
    const { enginesOptionsList } = this.state;
    if (type === 'option') {
      enginesOptionsList[engine][option].options.sort(function (x, y) { return x == value ? -1 : y == value ? 1 : 0; });
    } else if (type === 'number') {
      const num = typeof value === 'number' ? parseFloat(value) : value;
      const { valid_range } = enginesOptionsList[engine][option];
      if (!num || valid_range[0] <= num && num <= valid_range[1]) {
        enginesOptionsList[engine][option].options[0] = num;
      }
    } else if (type === 'boolean') {
      enginesOptionsList[engine][option].options[0] = checked;
    }
    this.setState({ enginesOptionsList })
  }

  // New added functions

  handleCoreChangeWeb = (e) => {
    const { coreNumberWeb } = this.state;
    coreNumberWeb[e.target.name] = parseInt(e.currentTarget.dataset.indexNumber, 10)
    this.setState({
      ...this.state,
      coreNumberWeb
    })
  }

  handleCounter = (value, option) => {
    let { counter, availableServers } = this.state;
    counter += value;

    if (counter >= 0 && counter < availableServers[option].length) {
      this.setState({ counter })
    }
  }

  orderServer = (cores, engine) => {
    const { enginesOptionsList, isOrdering, orderedCores } = this.state;
    const options = enginesOptionsList[engine];
    isOrdering[engine] = true;
    this.setState({ isOrdering });
    $.ajax({
      url: `/billing/order_server?cores=${cores}&engine=${engine}&options=${JSON.stringify(options)}&plugin=0`,
      method: 'GET',
      success: response => {
        if (response.error) {
          delete isOrdering[engine];
          this.setState({ isOrdering });
          console.log('ERROR ORDERING');
          return;
        }
        delete isOrdering[engine];
        orderedCores[engine] = cores;
        this.setState({ isOrdering, orderedCores });
      },
      error: err => {
        delete isOrdering[engine];
        this.setState({ isOrdering });
        console.log('IN CATCH', err);
      }
    });
  };

  stopServer = engine => {
    window.stopEngineAnalyze(engine, () => { });
    $.ajax({
      url: `/billing/stop_server?engine=${engine}`,
      method: 'GET',
      success: response => {
        if (response.error) {
          this.setState({ isStopping: false });
          console.log('ERROR STOPPING');
          return;
        } else {
          setTimeout(() => {
            window.stopEngine(engine);
          }, 500)
        }
      },
      error: err => {
        this.setState({ isStopping: false });
        console.log('IN CATCH', err);
      }
    });
  };

  _renderPreparingServer = () => {
    const { classes } = this.props;

    return (
      <div className={classes.selServerInfoContainer}>
        <Typography variant="h6" gutterBottom style={{ fontSize: window.innerWidth <= 1199 ? '1rem' : '1.5rem' }}>
          Preparing Server
        </Typography>
        <CircularProgress />
      </div>
    );
  };

  _renderLoadingAvailableServers = () => {
    const { classes } = this.props;

    return (
      <div className={classes.linerLoading}>
        <Typography variant="h6" gutterBottom style={{ fontSize: window.innerWidth <= 1199 ? '1rem' : '1.5rem' }}>
          Loading Servers
        </Typography>
        <LinearProgress />
        <LinearProgress color="secondary" />
      </div>
    );
  };


  _renderOrderedServerInfo = (engine) => {
    const { classes, orderedEnginesInfo } = this.props;
    const { isStopping, orderedCores } = this.state;
    const orderedEngine = orderedEnginesInfo[engine][0];

    let serverEngineInfoText = `${coreToKNode(null, orderedEngine.cores, engine).average} kN/s server running ${engine}`;
    if (engine === "stockfish10") {
      serverEngineInfoText = `${coreToKNode(null, orderedEngine.cores, engine).average} kN/s server running Stockfish 17`;
    }

    if (engine === "lc0") {
      let engineName = "LCZero";
      serverEngineInfoText = `GPU Cloud server running ${engineName}`;
    }
    let serverEngineInfo = <Typography variant='h5' style={{ maxWidth: '250px', fontSize: window.innerWidth <= 1199 ? '1rem' : '1.5rem' }} gutterBottom>{`You have rented a ${serverEngineInfoText}`}</Typography>
    if (orderedEngine.for_guests) {
      if (orderedCores[engine] === orderedEngine.cores) {
        if (orderedEngine.cores === 8) {
          serverEngineInfo = <Typography variant='h5' style={{ maxWidth: '250px', fontSize: window.innerWidth <= 1199 ? '1rem' : '1.5rem' }} gutterBottom>{`Free analysis on a server of 1,000 kN/s speed`}</Typography>
        }
        if (orderedEngine.cores === 16) {
          serverEngineInfo = <Typography variant='h5' style={{ maxWidth: '250px', fontSize: window.innerWidth <= 1199 ? '1rem' : '1.5rem' }} gutterBottom>{`Free analysis on a server of 10,000 kN/s speed`}</Typography>
        }
        if (orderedEngine.cores === 32) {
          serverEngineInfo = <Typography variant='h5' style={{ maxWidth: '250px', fontSize: window.innerWidth <= 1199 ? '1rem' : '1.5rem' }} gutterBottom>{`Free analysis on a server of up to 100,000 kN/s speed`}</Typography>
        }
      } else {
        serverEngineInfo = <Typography variant='h5' style={{ maxWidth: '250px', fontSize: window.innerWidth <= 1199 ? '1rem' : '1.5rem' }} gutterBottom>{`Temporary analysis on a server of 10,000 kN/s speed.`}</Typography>
      }
    }
    const stopServerButton = (
      <Button
        variant="contained"
        color="primary"
        fullWidth
        disabled={isStopping}
        onClick={() => this.stopServer(engine)}
      >
        Stop server
      </Button>
    );

    return (
      <div className={classes.selServerInfoContainer}>
        {serverEngineInfo}
        {stopServerButton}
      </div>
    );
  };

  // New added function

  _renderOrderedServerInfoForWeb = (engine) => {
    const { classes, orderedEnginesInfo, user } = this.props;
    const { isStopping, orderedCores } = this.state;
    const orderedEngine = orderedEnginesInfo[engine][0];

    let serverEngineInfoText = `${coreToKNode(null, orderedEngine.cores, engine).average} kN/s server running ${engine}`;
    if (engine === "stockfish10") {
      serverEngineInfoText = `${coreToKNode(null, orderedEngine.cores, engine).average} kN/s server running Stockfish 17`;
    }

    if (engine === "lc0") {
      let engineName = "LCZero";
      serverEngineInfoText = `GPU Cloud server running ${engineName}`;
    }
    let serverEngineInfo = <Typography variant='h5' style={{ fontSize: window.innerWidth <= 1199 ? '0.5rem' : '1rem' }} gutterBottom>{`You have rented a ${serverEngineInfoText}`}</Typography>
    if (orderedEngine.for_guests) {
      if (orderedCores[engine] === orderedEngine.cores) {
        if (orderedEngine.cores === 8) {
          serverEngineInfo = <Typography variant='h6' style={{ fontSize: window.innerWidth <= 1199 ? '0.4rem' : '0.8rem', padding: '5px' }} gutterBottom>Free analysis on a server of 1,000 kN/s speed</Typography>
        }
        if (orderedEngine.cores === 16) {
          serverEngineInfo = <Typography variant='h6' style={{ fontSize: window.innerWidth <= 1199 ? '0.4rem' : '0.8rem', padding: '5px' }} gutterBottom>Free analysis on a server of 10,000 kN/s speed</Typography>
        }
        if (orderedEngine.cores === 32) {
          serverEngineInfo = <Typography variant='h6' style={{ fontSize: window.innerWidth <= 1199 ? '0.4rem' : '0.8rem', padding: '5px' }} gutterBottom>Free analysis on a server of up to 100,000 kN/s speed</Typography>
        }
      } else {
        serverEngineInfo = <Typography variant='h6' style={{ fontSize: '0.8rem', padding: '5px' }} gutterBottom>{showEngineInfo(user.servers[engine][2])}</Typography>
      }
    }
    const stopServerButton = (
      <Button
        style={{
          width: "90%",
          margin: "0px auto",
          backgroundColor: "#f44336",
          color: "#ffffff"
        }}
        variant="contained"
        fullWidth
        disabled={isStopping}
        onClick={() => this.stopServer(engine)}
      >
        Stop server
      </Button>
    );

    return (
      <div className={classes.selServerInfoContainer} style={{ marginTop: 'auto', marginBottom: 0 }}>
        {serverEngineInfo}
        {stopServerButton}
      </div>
    );
  };

  _orderedEngineView = (engine) => {
    let view;
    const { isOrdering } = this.state;
    const { orderedEnginesInfo } = this.props;
    if (isOrdering[engine]) {
      view = this._renderPreparingServer()
    } else if (orderedEnginesInfo && orderedEnginesInfo[engine]) {
      view = this._renderOrderedServerInfoForWeb(engine);
    }

    return view;
  }

  _renderAvailableServersForWeb = () => {
    const { availableServers, enginesOptionsList, isOrdering, coreNumberWeb, isOpenOptionDialog, optionText } = this.state;
    const { orderedEnginesInfo, balance, user } = this.props;
    const { classes } = this.props;
    const restEngineList = Object.keys(availableServers).filter(serverName => serverName !== 'lc0' && serverName !== 'stockfish10');

    const handleOpenOptionDialog = (e, option) => {
      this.setState({
        isOpenOptionDialog: true,
        optionText: option
      });
    }

    const handleCloseOptionDialog = () => {
      this.setState({
        isOpenOptionDialog: false
      })
    }

    if (availableServers.length <= 0) {
      return this._renderLoadingAvailableServers();
    }
    const engineOptions = enginesOptionsList.stockfish10;
    const optionLabels = engineOptions ? Object.keys(engineOptions) : [];

    const engineOptionsLc0 = enginesOptionsList.lc0;
    const optionLabelsLc0 = engineOptionsLc0 ? Object.keys(engineOptionsLc0) : [];
    let lc0view;
    if (isOrdering.lc0 || orderedEnginesInfo.lc0) {
      lc0view = <Grid item className={classes.webView} md={4}>{this._orderedEngineView('lc0')}</Grid>
    } else if (availableServers.lc0) {
      lc0view = <Grid item className={classes.webView} md={4}>
        <Typography variant="h6" className={classes.webEngineTitle}>
          LCZero
        </Typography>
        <Typography variant="body1" className={classes.priceForWeb}>
          {availableServers.lc0[0].price_per_minute} coins/<small>min</small>
        </Typography>
        <Grid container align="center" justify="center" alignItems="center" direction="row-reverse">
          {
            optionLabelsLc0.map(option =>
              <>
                {
                  engineOptionsLc0[option].type === 'option' &&
                  <Grid item xs={8}>
                    <FormControl
                      style={{ margin: 0 }}>
                      <InputLabel id="demo-simple-select-label">
                        <Grid container spacing={0}>
                          <Grid xs={10}>
                            {option}
                          </Grid>
                          <Tooltip title="Click to see which LCZero network is best for you." placement="top" arrow>
                            <Grid xs={2} onClick={(e) => handleOpenOptionDialog(e, option)}>
                              <InfoIcon
                                color="primary"
                                fontSize="small"
                                style={{ marginTop: -2, marginLeft: 10, cursor: 'pointer' }}
                              />

                            </Grid>
                          </Tooltip>
                        </Grid>
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        disableUnderline="true"
                        value={engineOptionsLc0[option].options[0]}
                        onChange={(e) => this.handleChangeOptions(e, option, 'lc0', engineOptionsLc0[option].type)}
                        style={{ textAlign: 'left' }}>
                        {
                          engineOptionsLc0[option].options.map(opt =>
                            <MenuItem value={opt}>{opt}</MenuItem>
                          )
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                }
                {
                  engineOptionsLc0[option].type === 'number' &&
                  <Grid item xs={4} onClick={(e) => handleOpenOptionDialog(e, option)}>
                    <WhiteTextField
                      style={{ margin: 0 }}
                      id="standard-number"
                      disableUnderline='true'
                      label={
                        <Grid container spacing={0}>
                          <Tooltip title="Click to know more about cpuct." placement="top" arrow >
                            <Grid xs={2}>
                              <InfoIcon
                                color="primary"
                                fontSize="small"
                                style={{ marginTop: -2, marginRight: 15, cursor: 'pointer' }}
                              />
                            </Grid>
                          </Tooltip>
                          <Grid xs={10}>
                            {option}
                          </Grid>
                        </Grid>
                      }
                      type="number"
                      error={isNaN(parseFloat(engineOptionsLc0[option].options[0]))}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ min: engineOptionsLc0[option].valid_range[0], max: engineOptionsLc0[option].valid_range[1], step: "0.1" }}
                      margin="normal"
                      value={engineOptionsLc0[option].options[0]}
                      onChange={(e) => this.handleChangeOptions(e, option, 'lc0', engineOptionsLc0[option].type)}
                    />
                  </Grid>
                }
                {isOpenOptionDialog && <OptionDialog isOpen={isOpenOptionDialog} isClose={handleCloseOptionDialog} infoText={engineOptionsLc0[optionText].description} />}
              </>
            )
          }
        </Grid>

        {showAnalizeButton(
          user,
          availableServers.lc0[0].cores,
          availableServers.lc0[0].price_per_minute
        ) ? (
          <Button
            variant="contained"
            color="primary"
            fullWidth
            style={{
              pointerEvents: 'auto',
              width: '90%',
              margin: '0px auto'
            }}
            disabled={orderedEnginesInfo.lc0}
            onClick={() =>
              this.orderServer(availableServers.lc0[0].cores, 'lc0')
            }
          >
            Analyze
          </Button>
        ) : (
          <ButtonWithTooltip
            variant="contained"
            color="primary"
            fullWidth
            style={{
              pointerEvents: 'auto',
              width: '90%',
              margin: '0px auto'
            }}
            tooltipText="To order a server buy any package"
            disabled
          >
            Analyze
          </ButtonWithTooltip>
        )}
        {orderedEnginesInfo.lc0 &&
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            disabled={!orderedEnginesInfo.lc0}
            onClick={() =>
              this.stopServer('lc0')
            }
          >
            Stop
          </Button>
        }
      </Grid>
    } else {
      // View for LC0 when unavailable
      lc0view =
        <Grid item className={classes.webView} md={4}>
          <Typography variant="h6" gutterBottom className={classes.webEngineTitle} style={{ color: "grey" }}>
            LCZero
          </Typography>
          <Typography variant="body1" className={classes.priceForWeb} style={{ color: "grey" }}>
            <b>Price: </b>coins/<small>min</small>
          </Typography>
          <Grid container align="center" justify="center" alignItems="center" >
            <>
              <Grid item xs={6} style={{ color: "grey" }}>
                {'network'}
              </Grid>
              <Grid item xs={6} style={{ color: "grey" }}>
                {'cpuct'}
              </Grid>
            </>
          </Grid>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            style={{ pointerEvents: 'auto', width: "90%", margin: "0px auto" }}
            disabled='true'
            onClick={() =>
              this.orderServer(availableServers.lc0[0].cores, 'lc0')
            }
          >
            Analize
          </Button>
        </Grid>
    }

    return (
      <Grid container spacing={24} wrap="nowrap">
        {isOrdering.stockfish10 || orderedEnginesInfo.stockfish10 ?
          <Grid item className={classes.webView} md={4}>
            {this._orderedEngineView('stockfish10')}
          </Grid> :
          <Grid item className={classes.webView} md={4}>
            <Grid container spacing={0}>
              {
                optionLabels.map(option =>
                  <Grid xs={12}>
                    {
                      engineOptions[option].type === 'option' &&
                      <FormControl>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          disableUnderline='true'
                          value={engineOptions[option].options[0]}
                          onChange={(e) => this.handleChangeOptions(e, option, 'stockfish10', engineOptions[option].type)}
                          className={classes.webEngineTitle}>
                          {
                            engineOptions[option].options.map(opt =>
                              <MenuItem value={opt} selected>{opt}</MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    }
                  </Grid>
                )
              }
            </Grid>
            {
              console.log('availableServers', availableServers)
            }
            {
              console.log('coreNumberWeb', coreNumberWeb)
            }
            {
              (availableServers.stockfish10[coreNumberWeb['stockfish10']] || availableServers.stockfish10[0]).price_per_minute === 0 ?
                <Typography variant="body1" className={classes.priceForWeb}>
                  Free
                </Typography>
                :
                <Typography variant="body1" className={classes.priceForWeb}>
                  {(availableServers.stockfish10[coreNumberWeb['stockfish10']] || availableServers.stockfish10[0]).price_per_minute} coins/<small>min</small>
                </Typography>
            }
            <Grid container align="center" justify="center" alignItems="center" >
              <Grid item xs={12}>
                <FormControl>
                  <FormControlLabel
                    style={{ margin: 0, cursor: "text" }}
                    control={
                      <Select
                        disableUnderline='true'
                        value={(availableServers.stockfish10[coreNumberWeb['stockfish10']] || availableServers.stockfish10[0]).cores}
                        onChange={(e) => this.handleCoreChangeWeb(e)}
                        name={'stockfish10'}
                      >
                        {
                          availableServers.stockfish10.map((opt, coreIndex) => {
                            const { subscription, balance } = user;
                            const enabledVariation = (
                              <MenuItem value={opt.cores} key={coreIndex} data-index-number={coreIndex}>
                                {coreToKNode(null, opt.cores, 'stockfish10').caption}
                              </MenuItem>
                            );
                            const disabledVariation = (
                              <MenuItem disabled={true} value={opt.cores} key={coreIndex} data-index-number={coreIndex}>
                                {coreToKNode(null, opt.cores, 'stockfish10').caption}
                              </MenuItem>
                            );

                            if (opt.cores === 8) {
                              if (!subscription || (subscription && (new Date(subscription.valid_till) < Date.now()))) {
                                return enabledVariation
                              }
                            }

                            if (opt.cores === 16) {
                              if (!subscription) {
                                return disabledVariation
                              }
                              if (subscription) {
                                if (parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-month'] || parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-year']) {
                                  if ((new Date(subscription.valid_till) >= Date.now())) {
                                    return enabledVariation
                                  } else {
                                    return disabledVariation
                                  }
                                }
                              }
                            }

                            if (opt.cores === 32) {
                              if (!subscription || parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-month'] || parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-year']) {
                                return disabledVariation
                              }
                              else if (subscription) {
                                if ((new Date(subscription.valid_till) >= Date.now())) {
                                  return enabledVariation
                                } else {
                                  return disabledVariation
                                }
                              }
                            }

                            if (opt.cores > 32) {
                              if (balance > 0) {
                                return enabledVariation
                              }
                              else {
                                return disabledVariation
                              }
                            }
                          })
                        }
                      </Select>
                    }
                    label={<Typography className={classes.formControlLabelWeb}>Server:</Typography>}
                    labelPlacement="start"
                  />
                </FormControl>
              </Grid>
            </Grid>
            {
              showAnalizeButton(user, (availableServers.stockfish10[coreNumberWeb['stockfish10']] || availableServers.stockfish10[0]).cores, (availableServers.stockfish10[coreNumberWeb['stockfish10']] || availableServers.stockfish10[0]).price_per_minute)
                ?
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ pointerEvents: 'auto', width: "90%", margin: "0px auto" }}
                  disabled={orderedEnginesInfo.stockfish10}
                  onClick={() =>
                    this.orderServer((availableServers.stockfish10[coreNumberWeb['stockfish10']] || availableServers.stockfish10[0]).cores, 'stockfish10')
                  }
                >
                  Analyze
                </Button> :
                <ButtonWithTooltip
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ pointerEvents: 'auto', width: "90%", margin: "0px auto" }}
                  tooltipText="To order a server buy any package"
                  disabled>
                  Analyze

                </ButtonWithTooltip>

            }
            {orderedEnginesInfo.stockfish10 &&
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                disabled={!orderedEnginesInfo.stockfish10}
                onClick={() =>
                  this.stopServer('stockfish10')
                }
              >
                Stop
              </Button>
            }
          </Grid>
        }
        {lc0view}
        {
          <Grid item md={4} className={classes.webView}>
            <ScrollMenu
              transition={2}
              arrowLeft={<KeyboardArrowLeftIcon className={classes.scrollIcon} />}
              arrowRight={<KeyboardArrowRightIcon className={classes.scrollIcon} />}
              data={restEngineList.map((serverName, index) => {
                if (isOrdering[serverName] || orderedEnginesInfo[serverName]) {
                  return (
                    <Grid style={{ textAlign: "center", width: "15vw", whiteSpace: 'normal' }} key={index}>
                      {this._orderedEngineView(serverName)}
                    </Grid>
                  )
                }
                return (<Grid item xs={12} style={{ boxShadow: 'rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px', textAlign: "center", width: "15vw", marginRight: 2 }} key={index}>
                  <Grid container spacing={0} style={{ marginTop: 10 }} >
                    <Grid xs={12}>
                      {
                        enginesOptionsList[serverName] ?
                          <Typography variant="h6" sx={{ pt: 0 }} gutterBottom className={classes.webEngineTitle}>{
                            enginesOptionsList[serverName].engine.type === 'option' &&
                            <FormControl>
                              <SelectField
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                disableUnderline='true'
                                value={enginesOptionsList[serverName].engine.options[0]}
                                onChange={(e) => this.handleChangeOptions(e, Object.keys(enginesOptionsList[serverName])[0], serverName, enginesOptionsList[serverName].engine.type)}
                              >
                                {
                                  enginesOptionsList[serverName].engine.options.map(opt =>
                                    <MenuItem value={opt} selected >{opt}</MenuItem>
                                  )
                                }
                              </SelectField>
                            </FormControl>
                          }</Typography>
                          :
                          <Typography variant="h6" gutterBottom className={classes.webEngineTitle}>{ENGINES_NAMES[serverName]}</Typography>

                      }
                    </Grid>
                  </Grid>
                  {
                    (availableServers[serverName][coreNumberWeb[serverName]] || availableServers[serverName][0]).price_per_minute === 0 ?
                      <Typography variant="body1" className={classes.priceForWeb}>
                        Free
                      </Typography>
                      :
                      <Typography variant="body1" className={classes.priceForWeb}>
                        {(availableServers[serverName][coreNumberWeb[serverName]] || availableServers[serverName][0]).price_per_minute} coins/<small>min</small>
                      </Typography>
                  }
                  <Grid container align="center" justify="center" alignItems="center" >
                    <Grid item xs={12}>
                      <FormControl>
                        <FormControlLabel
                          style={{ marginBottom: 6, cursor: "text" }}
                          label={<Typography className={classes.formControlLabelWeb}>Server:</Typography>}
                          labelPlacement="start"
                          control={
                            <Select
                              value={(availableServers[serverName][coreNumberWeb[serverName]] || availableServers[serverName][0]).cores}
                              onChange={(e) => this.handleCoreChangeWeb(e)}
                              disableUnderline='true'
                              name={serverName}
                            >
                              {
                                availableServers[serverName].map((item, coreIndex) => {
                                  const { subscription, balance } = user;
                                  const enabledVariation = (
                                    <MenuItem value={item.cores} data-index-number={coreIndex}>
                                      {coreToKNode(null, item.cores, serverName).caption}
                                    </MenuItem>
                                  );
                                  const disabledVariation = (
                                    <MenuItem disabled={true} value={item.cores} data-index-number={coreIndex}>
                                      {coreToKNode(null, item.cores, serverName).caption}
                                    </MenuItem>
                                  );

                                  if (item.cores === 8) {
                                    if (!subscription || (subscription && (new Date(subscription.valid_till) < Date.now()))) {
                                      return enabledVariation
                                    }
                                  }

                                  if (item.cores === 16) {
                                    if (!subscription) {
                                      return disabledVariation
                                    }
                                    if (subscription) {
                                      if (parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-month'] || parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-year']) {
                                        if ((new Date(subscription.valid_till) >= Date.now())) {
                                          return enabledVariation
                                        } else {
                                          return disabledVariation
                                        }
                                      }
                                    }
                                  }

                                  if (item.cores === 32) {
                                    if (!subscription || parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-month'] || parseInt(subscription.product_id) === PRODUCT_IDS['Amateur-year']) {
                                      return disabledVariation
                                    }
                                    else if (subscription) {
                                      if ((new Date(subscription.valid_till) >= Date.now())) {
                                        return enabledVariation
                                      } else {
                                        return disabledVariation
                                      }
                                    }
                                  }
                                  if (item.cores > 32) {
                                    if (balance > 0) {
                                      return enabledVariation
                                    }
                                    else {
                                      return disabledVariation
                                    }
                                  }
                                })
                              }
                            </Select>
                          }
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  {
                    showAnalizeButton(user, (availableServers[serverName][coreNumberWeb[serverName]] || availableServers[serverName][0]).cores, (availableServers[serverName][coreNumberWeb[serverName]] || availableServers[serverName][0]).price_per_minute)
                      ? <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ pointerEvents: 'auto' }}
                        disabled={orderedEnginesInfo[serverName]}
                        onClick={() =>
                          this.orderServer((availableServers[serverName][coreNumberWeb[serverName]] || availableServers[serverName][0]).cores, serverName)
                        }
                      >
                        Analyze
                      </Button> :
                      <ButtonWithTooltip
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ pointerEvents: 'auto', width: "90%", margin: "0px auto" }}
                        tooltipText="To order a server buy any package"
                        disabled>
                        Analyze

                      </ButtonWithTooltip>

                  }
                  {orderedEnginesInfo[serverName] &&
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      disabled={!orderedEnginesInfo[serverName]}
                      onClick={() =>
                        this.stopServer(serverName)
                      }
                    >
                      Stop
                    </Button>
                  }
                </Grid>)

              })}
            />
          </Grid>
        }
      </Grid>
    );
  }


  _renderAvailableServersForMobile = (engine) => {
    const { availableServers, selectedEngine, enginesOptionsList } = this.state;
    const { orderedEnginesInfo, user } = this.props;
    const { classes } = this.props;

    const handlePopoverOpen = (option, event) => {
      enginesOptionsList[engine][option].anchorEl = event.currentTarget;
    }

    const handlePopoverClose = (option) => {
      delete enginesOptionsList[selectedEngine][option].anchorEl;
    }

    const server = availableServers[engine][this.state.counter];
    if (!server) {
      return this._renderPreparingServer();
    }
    const servInfo = coreToKNode(null, server.cores, selectedEngine);
    const engineOptions = enginesOptionsList[selectedEngine];
    const optionLabels = engineOptions ? Object.keys(engineOptions) : [];

    return (
      <Card className={classes.card}>
        <CardContent>
          <div>
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              onClick={() => { this.handleCounter(-1, engine) }}>
              <ArrowLeftIcon />
            </IconButton>
            {this.state.counter + 1} / {availableServers[engine].length}
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              onClick={() => { this.handleCounter(1, engine) }}>
              <ArrowRightIcon />
            </IconButton>
          </div>
          <Typography variant="h5" style={{ fontSize: window.innerWidth <= 1199 ? '1rem' : '1.5rem' }} gutterBottom>
            {servInfo.caption}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Speed: <b>{servInfo.average}</b> kN/s
          </Typography>
          {optionLabels.length > 0 && <Divider />}

          <Grid container spacing={0} style={{ marginTop: 10 }}>
            {
              optionLabels.map(option =>
                <Grid xs={12}>
                  {
                    engineOptions[option].type === 'option' &&
                    <FormControl className={classes.formControl}>
                      <InputLabel id="demo-simple-select-label">
                        <Grid container spacing={0}>
                          <Grid xs={10}>
                            {option}
                          </Grid>
                          <Grid xs={2}>
                            <InfoIcon
                              color="primary"
                              fontSize="small"
                              onMouseEnter={(e) => handlePopoverOpen(option, e)}
                              onMouseLeave={(e) => handlePopoverClose(option, e)}
                              style={{ marginTop: -2, marginLeft: 10 }}
                            />
                          </Grid>
                        </Grid>
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={engineOptions[option].options[0]}
                        onChange={(e) => this.handleChangeOptions(e, option, selectedEngine, engineOptions[option].type)}
                        style={{ textAlign: 'left' }}>
                        {
                          engineOptions[option].options.map(opt =>
                            <MenuItem value={opt}>{opt}</MenuItem>
                          )
                        }
                      </Select>
                    </FormControl>
                  }
                  {
                    engineOptions[option].type === 'number' &&
                    <TextField
                      id="standard-number"
                      label={
                        <Grid container spacing={0}>
                          <Grid xs={10}>
                            {option}
                          </Grid>
                          <Grid xs={2}>
                            <InfoIcon
                              color="primary"
                              fontSize="small"
                              onMouseEnter={(e) => handlePopoverOpen(option, e)}
                              onMouseLeave={(e) => handlePopoverClose(option, e)}
                              style={{ marginTop: -2, marginLeft: 10 }}
                            />
                          </Grid>
                        </Grid>
                      }
                      type="number"
                      error={isNaN(parseFloat(engineOptions[option].options[0]))}
                      className={classes.formControl}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ min: engineOptions[option].valid_range[0], max: engineOptions[option].valid_range[1], step: "0.1" }}
                      margin="normal"
                      value={engineOptions[option].options[0]}
                      onChange={(e) => this.handleChangeOptions(e, option, selectedEngine, engineOptions[option].type)}
                    />
                  }
                  {
                    engineOptions[option].type === 'boolean' &&
                    <FormControlLabel
                      label={
                        <Grid container spacing={0}>
                          <Grid xs={10}>
                            {option}
                          </Grid>
                          <Grid xs={2}>
                            <InfoIcon
                              color="primary"
                              fontSize="small"
                              onMouseEnter={(e) => handlePopoverOpen(option, e)}
                              onMouseLeave={(e) => handlePopoverClose(option, e)}
                              style={{ marginTop: -2, marginLeft: 10 }}
                            />
                          </Grid>
                        </Grid>
                      }
                      labelPlacement="start"
                      control={
                        <Checkbox
                          checked={engineOptions[option].options[0]}
                          onChange={(e) => this.handleChangeOptions(e, option, selectedEngine, engineOptions[option].type)}
                          value='checked'
                          color="primary"
                        />
                      }
                    />
                  }
                  <Popover
                    id="mouse-over-popover"
                    className={classes.popover}
                    classes={{
                      paper: classes.paper,
                    }}
                    open={engineOptions[option].description && engineOptions[option].description.length > 0 ? Boolean(engineOptions[option].anchorEl) : false}
                    anchorEl={engineOptions[option].anchorEl}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    onClose={(e) => handlePopoverClose(option, e)}
                    disableRestoreFocus
                  >
                    <Typography>{engineOptions[option].description}</Typography>
                  </Popover>
                </Grid>
              )
            }
          </Grid>
          <Divider />
          <Typography variant="body1" style={{ marginTop: 20 }}>
            Price: <b>{server.price_per_minute} coins</b>/<small>min</small>
          </Typography>
        </CardContent>
        <CardActions>
          {showAnalizeButton(
            user,
            server.cores,
            server.price_per_minute
          ) ? (
            <Button
              variant="contained"
              color="primary"
              fullWidth
              style={{ pointerEvents: 'auto' }}
              disabled={orderedEnginesInfo[engine]}
              onClick={() => this.orderServer(server.cores, engine)}
            >
              Order
            </Button>
          ) : (
            <Tooltip
              title="To order a server buy any package"
              placement="top"
            >
              <Button
                variant="contained"
                color="primary"
                fullWidth
                style={{ pointerEvents: 'auto' }}
                disabled={true}
                onClick={() => this.orderServer(server.cores, engine)}
              >
                Order
              </Button>
            </Tooltip>
          )}
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            disabled={!orderedEnginesInfo[engine]}
            onClick={() =>
              this.stopServer(engine)
            }
          >
            Stop
          </Button>
        </CardActions>
      </Card>
    );

  };

  getView = (engine) => {
    const { isOrdering } = this.state;
    const { orderedEnginesInfo } = this.props;
    let view = this._renderAvailableServersForMobile(engine);
    if (isOrdering[engine]) {
      view = this._renderPreparingServer();
    } else if (orderedEnginesInfo && orderedEnginesInfo[engine]) {

      view = this._renderOrderedServerInfo(engine);
    }
    return view;
  }


  render() {
    const { open, anchorRef, availableServers, selectedEngine } = this.state;
    const { orderedEnginesInfo } = this.props;
    const enginesTitles = Object.keys(availableServers);
    const { classes } = this.props;
    return !isMobile ? this._renderAvailableServersForWeb() : (
      <Grid container direction="column" alignItems="center">
        <Grid item xs={12}>
          <Button variant='contained' color='primary' ref={anchorRef} onClick={this.showEngines} endIcon={<ArrowDropDownIcon />}>
            <Badge color="error" variant="dot" invisible={(Object.keys(orderedEnginesInfo).length === 0)} />
            <span style={{ marginLeft: 10 }}>order</span>
          </Button>
          <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper className={classes.paper2}>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <div>
                      { /*Object.keys(orderedEnginesInfo).length > 0 ?
                        this._renderOrderedServerInfo(Object.keys(orderedEnginesInfo)[0]) :*/
                        enginesTitles.map((option, index) => (
                          <ExpansionPanel expanded={selectedEngine === option} onChange={(event) => this.handleMenuItemClick(event, option)}>
                            <ExpansionPanelSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                            >
                              <Typography>
                                <span>
                                  <Badge color="error" variant="dot" invisible={!(Object.keys(orderedEnginesInfo).includes(ENGINES[index]))} />
                                  <span style={{ marginLeft: 10 }}> {ENGINES_NAMES[option]}</span>
                                </span>
                              </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{ textAlign: 'center' }}>
                              <div style={{ flex: 'auto', width: "max-content" }}>
                                <Typography>
                                  {selectedEngine === option && this.getView(option)}
                                </Typography>
                              </div>
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        ))}
                    </div>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Grid>
      </Grid>
    );
  }
}


export default withStyles(styles)(SplitButton);
